import { apiCall } from './base';

export const updateDegree =(hash, { immediately = false, ...data }) =>
  apiCall(`/degrees/${hash}`, { method: 'PUT', data, immediately });
